import React, { useState } from 'react';
import PropTypes from 'prop-types';
import PlanOptionMenuCard from './PlanOptionMenuCard';

const PlanOptionMenu = ({
  handleSelectButtonClick,
  itinerary,
  itineraryIndex,
  selectedOutboundDate,
  selectedGoods,
}) => {

  const sortedItineraryGoods = itinerary.goods.length > 1 ? [...itinerary.goods].sort((a, b) => {
    const seqA = typeof a.seq === 'number' ? a.seq : parseInt(a.seq, 10);
    const seqB = typeof b.seq === 'number' ? b.seq : parseInt(b.seq, 10);
    return seqA - seqB;
  }) : itinerary.goods;

  const defaultDisplayedGoods = sortedItineraryGoods.length >= 2 
  ? sortedItineraryGoods.slice(0, 2) 
  : sortedItineraryGoods;

  const defaultHiddenGoods = sortedItineraryGoods.length >= 2 
  ? sortedItineraryGoods.slice(2) 
  : [];

  let defaultIsAccordionOpen = false;
  if(selectedGoods) {
    const defaultHiddenGoodsIsSelected = defaultHiddenGoods.find((goods) => {
      return selectedGoods.goodsPlanCode === goods.goodsPlanCode;
    });
    if(defaultHiddenGoodsIsSelected) {
      defaultIsAccordionOpen = true;
    }
  }
  const [isAccordionOpen, setIsAccordionOpen] = useState(defaultIsAccordionOpen);

  return (
    <div key={`itinerary-${itineraryIndex}`} className="pagePlanOptionMenu">
      <div className="pagePlanOptionMenuHeader">
        <h2 className="pagePlanOptionMenuHeaderTitle">メニュー{itineraryIndex + 1}</h2>
      </div>
      {defaultDisplayedGoods
        .map((goods, goodsIndex) => {
          const isSelected = selectedGoods ? selectedGoods.goodsPlanCode === goods.goodsPlanCode : false;
          return (
            <PlanOptionMenuCard 
              key={`goods-${itineraryIndex}-${goodsIndex}`}
              handleSelectButtonClick={handleSelectButtonClick} 
              isSelected={isSelected}
              goods={goods}
              selectedOutboundDate={selectedOutboundDate}
              itineraryIndex={itineraryIndex}
            />);
        })}

      {defaultHiddenGoods.length > 0 && (
        <div className="pageAccordion">
          <div className="pageAccordionButton">
            <button className={`button pageAccordionOpen ${isAccordionOpen ? 'is-hidden' : ''}`} onClick={() => setIsAccordionOpen(!isAccordionOpen)}>
              <span>すべてのタビサキMenuを見る</span>
            </button>
          </div>
          {isAccordionOpen && (
            <div className={`pageAccordionContent ${isAccordionOpen ? 'is-open' : ''}`}>
              {
              defaultHiddenGoods
              .map((goods, goodsIndex) => {
                const isSelected = selectedGoods ? selectedGoods.goodsPlanCode === goods.goodsPlanCode : false;
                return (
                  <PlanOptionMenuCard 
                    key={`goods-${itineraryIndex}-${goodsIndex}`}
                    handleSelectButtonClick={handleSelectButtonClick} 
                    isSelected={isSelected}
                    goods={goods}
                    selectedOutboundDate={selectedOutboundDate}
                    itineraryIndex={itineraryIndex}
                  />);
              })}

              <div className="pageAccordionButton">
                <button className={`button pageAccordionClose ${isAccordionOpen ? 'is-visible' : 'is-hidden'}`} onClick={() => setIsAccordionOpen(false)}>
                  <span>閉じる</span>
                </button>
              </div>
            </div>
          )}
        </div>
        )}
    </div>
  );
};

PlanOptionMenu.defaultProps = {
  handleSelectButtonClick: () => {},
  itinerary: {},
  itineraryIndex: 0,
  selectedOutboundDate: '',
  selectedGoods: null,
};


PlanOptionMenu.propTypes = {
    handleSelectButtonClick: PropTypes.func.isRequired,
    itinerary: PropTypes.object.isRequired,
    itineraryIndex: PropTypes.number.isRequired,
    selectedOutboundDate: PropTypes.string.isRequired,
    selectedGoods: PropTypes.object,
};

export default PlanOptionMenu;